<template>
  <div class="entry-dialog">
    <!-- 增加m灰色蒙层 -->
    <div class="bg-gray" v-if="middleVisible"></div>
    <dialog-card :visible.sync="middleVisible" :title="title" @on-close="onCancel">
      <template v-if="showCountryTip" #countryMsg>
        <el-alert type="warning" show-icon :closable="false" simple>
          <span slot="title">
            <t
              class="choose-country-style"
              :lang="$t('HPP-web_register_country_tip_msg', { 0: countryLabel })"
              tag="span"
            >
              <b style="color: rgb(215, 0, 15)"></b>
            </t>
          </span>
        </el-alert>
      </template>
      <account-login
        :auto-email="autoEmail"
        :title.sync="realyTitle"
        ref="login"
        v-show="dialogType === 'login'"
        @to-reset="open('reset', { autoEmail: $event })"
        @close-card="onCloseHPCLogin"
      />
      <choose-identity v-if="dialogType === 'chooseId'" @go-register="goRegister" />
      <account-register-check-email
        v-if="middleVisible"
        :auto-email="autoEmail"
        :title.sync="realyTitle"
        ref="register"
        v-show="dialogType === 'register'"
      />
      <account-reset ref="reset" v-show="dialogType === 'reset'" :auto-email="autoEmail" />
      <template v-if="footContext" #footer>
        <span class="foot-text">{{ $t(footContext.span) + '&nbsp;' }}</span>
        <el-button @click="footerBtn" class="foot-button" type="link">{{ $t(footContext.btn) }}</el-button>
      </template>
    </dialog-card>
    <select-service-type
      :onehikid="true"
      @comfirm="chooseTypeFn.resolve && chooseTypeFn.resolve()"
      v-model="showAccountType"
    />
    <el-dialog
      :title="$t('warm_tips')"
      :visible.sync="updatedOHIDialog"
      :area="480"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="updated_OHI_dialog_content">
        <div class="updated_OHI_dialog_fail">{{ $t('error_tip_prefix_30') }}</div>
        <div class="updated_OHI_dialog_expain">{{ $t('can_not_use_hpc_login') }}</div>
        <div class="updated_OHI_dialog_img">
          <img src="../../img/portal_OHI_update.png.webp" alt>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updatedOHIDialog = false">{{ $t('go_to_login') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      v-if="azureLoginShow"
      :title="$t('account')"
      :visible.sync="azureLoginShow"
      :area="520"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="onCloseAzureLoginDialog"
      class="third-login-dialog"
    >
      <el-form
        ref="azureLoginForm"
        label-position="top"
        :model="azureLoginForm"
        :rules="azureLoginRules"
        class="azure-login-form"
        label-width="24px"
      >
        <el-form-item :label="$t('e-mail')" prop="email" ref="emailFormItem" v-if="!googleLoginShow">
          <el-input
            :tips="$t('v_email')"
            :placeholder="$t('e-mail')"
            v-model.trim="azureLoginForm.email"
            @keypress.enter.native="confirmAzureEmail"
            :maxlength="128"
          ></el-input>
          <div class="el-form-item__error my-false-item" v-if="noEmailErrorTxt">{{ noEmailErrorTxt }}</div>
        </el-form-item>
        <!-- 公司识别码 -->
        <el-form-item :label="$t('HPP-web_company_idetification_code_name')" prop="idpId" ref="idpIdFormItem" v-if="googleLoginShow">
          <el-input
            :placeholder="$t('please_enter')"
            v-model.trim="azureLoginForm.idpId"
            @keypress.enter.native="confirmAzureEmail"
            :maxlength="128"
          ></el-input>
          <div class="el-form-item__error my-false-item" v-if="idpIdErrorTxt">{{ idpIdErrorTxt }}</div>
        </el-form-item>
        <el-form-item :label="$t('enter_img_verify_code')" prop="verifyCode" v-if="needAzureVerifyCode" ref="verifyAzureCodeFormItem">
          <el-input
            v-model.trim="azureLoginForm.verifyCode"
            :placeholder="$t('enter_img_verify_code')"
            class="azure-login-code-input"
            v-input-limit
            data-input-type="alphanumeric"
            :maxlength="4"
            @keypress.enter.native="confirmAzureEmail"
          ></el-input>
          <img v-if="AzureVerifyImg" :title="$t('HPP-web_change_azure_code_msg')" :src="AzureVerifyImg" alt @click="changeAzureCode" class="azure-login-code-pic" crossorigin="anonymous">
          <div class="el-form-item__error my-false-item" v-if="verifyErrorTxt">{{ $t(verifyErrorTxt) }}</div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="confirmAzureEmail()" :loading="confirmLoading">{{ googleLoginShow ? $t('confirm') : $t('next_step') }}</el-button>
        <el-button @click="onCloseAzureLoginDialog()" v-if="googleLoginShow">{{ $t('cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import SelectServiceType from './select-service-type.vue';
import DialogCard from '@/Common/components/cloud-dialog-card.vue';
import chooseIdentity from './choose-identity.vue';
import AccountLogin from './account-login.vue';
import AccountRegisterCheckEmail from './account-register-check-email.vue';
import AccountReset from './account-reset.vue';
import isMobile from '@pro/common/utils/isMobile';
import '@/Common/styles/hui-var.scss';
import { COUNTRY_OR_REGION_LIST } from '@pro/common/consts/country-or-region';
import { isAccountNeedUpgrade } from '@pro/common/dao/upgrade-strategy.js';
import storage from '@/Common/libs/storage';

export default {
  name: 'EntryDialogCard',
  components: {
    DialogCard,
    AccountLogin,
    AccountRegisterCheckEmail,
    AccountReset,
    chooseIdentity,
    SelectServiceType
  },
  data() {
    return {
      // chooseId login register reset
      dialogType: 'login',
      canRegister: true,
      autoEmail: '',
      showAccountType: false,
      middleVisible: false,
      realyTitle: '',
      chooseTypeFn: {
        resolve: null,
        reject: null
      },
      updatedOHIDialog: false,
      country: -1,
      azureLoginShow: false,
      azureLoginForm: {
        email: sessionStorage.getItem('accountEmailCache') || '',
        verifyCode: '',
        idpId: sessionStorage.getItem('googleLoginSucceeded') ? sessionStorage.getItem('googleIpdId') : ''
      },
      AzureVerifyImg: '',
      needAzureVerifyCode: false,
      noEmailErrorTxt: '',
      verifyErrorTxt: '',
      idpIdErrorTxt: '',
      azureSessionId: null,
      googleLoginShow: false,
      confirmLoading: false
    };
  },
  computed: {
    title() {
      const map = {
        chooseId: 'choose_id',
        login: 'label_welcome_login',
        register: 'register_now',
        reset: 'reset_password'
      };
      return this.realyTitle ? this.realyTitle : this.$t(map[this.dialogType]);
    },
    showCountryTip() {
      return this.dialogType === 'chooseId';
    },
    countryLabel() {
      let country = '';
      COUNTRY_OR_REGION_LIST().forEach((e) => {
        if (e.index === Number(this.country)) {
          country = this.$t(e.label);
        }
      });
      return country;
    },
    footContext() {
      if (!this.canRegister && this.dialogType === 'login') {
        return false;
      }
      const map = {
        register: {
          span: 'existing_account',
          btn: 'login_now'
        },
        login: {
          span: 'no_existing_account',
          btn: 'register_now'
        },
        reset: {
          span: 'find_password',
          btn: 'login_now'
        }
      };
      return map[this.dialogType];
    },

    azureLoginRules() {
      return {
        email: [
          { type: 'string', required: true, message: this.$t('v_not_empty'), trigger: 'none' },
          {
            type: 'string',
            required: true,
            pattern: /\S/,
            message: this.$t('v_not_only_include_space'),
            trigger: 'none'
          },
          {
            type: 'string',
            required: true,
            pattern: /^(?=.*@.{1,127}).{1,128}$/,
            message: this.$t('v_email'),
            trigger: 'none'
          }
          //   {
          //     type: 'string',
          //     required: true,
          //     pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
          //     message: this.$t('v_email'),
          //   },

        ],
        idpId: this.googleLoginShow
          ? [
            { type: 'string', required: true, message: this.$t('v_not_empty'), trigger: 'none' },
            {
              type: 'string',
              required: true,
              pattern: /\S/,
              message: this.$t('v_not_only_include_space'),
              trigger: 'none'
            }
          ]
          : [],
        verifyCode: this.needAzureVerifyCode
          ? [
            { type: 'string', required: true, message: this.$t('v_not_empty'), trigger: 'none' },
            {
              type: 'string',
              required: true,
              pattern: /\S/,
              message: this.$t('v_not_only_include_space'),
              trigger: 'none'
            }
          ]
          : []
      };
    }
  },
  watch: {
    showAccountType(value) {
      if (!value) {
        this.dialogType = 'login'; // 关闭时还原默认值
      }
    },
    dialogType(value) {
      if (value && value === 'chooseId') {
        this.country = Number(localStorage.getItem('hik_connect_pro_country'));
      }
    },
    'azureLoginForm.email'(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.noEmailErrorTxt = '';
      }
    },
    'azureLoginForm.idpId'(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.idpIdErrorTxt = '';
      }
    }
  },
  methods: {
    open(dialogType, { canRegister, autoEmail } = {}) {
      if (dialogType === 'register') {
        this.$refs.register?.resetRegisterForm();
      }
      this.$refs[dialogType] && this.$refs[dialogType].resetForm();
      this.dialogType = dialogType;
      this.canRegister = canRegister ?? this.canRegister;
      this.autoEmail = autoEmail ?? this.autoEmail;
      this.middleVisible = true;
      this.realyTitle = '';
    },
    close() {
      this.middleVisible = false;
    },
    onCancel() {
      this.dialogType = 'login'; // 关闭时还原默认值
      // 邀请好友注册模式下，取消即退出注册流程
      if (localStorage.getItem('Invite_Friend_Jumped') && this.dialogType === 'chooseId') {
        localStorage.removeItem('Invite_Friend_Jumped');
        window.location.href = window.location.origin;
      }
    },
    /**
     * 选择完身份后跳转到注册
     * @param {'hpc'|'onehikid'} type
     */
    async goRegister(type) {
      // 如果是手机上注册，以选择身份弹窗作为底层背景，不关闭
      if (!isMobile()) {
        this.close();
      }
      if (type === 'hpc') {
        this.toRegister(type);
        return;
      }
      if (localStorage.getItem('chooseType')) {
        sessionStorage.setItem('register-onehikid-type', 'End User');
      } else {
        // 如果没有选择过服务商类型，则打开选择服务商类型的弹窗
        this.showAccountType = true;
        await this.chooseType();
        this.showAccountType = false;
      }
      this.toRegister(type);
    },
    chooseType() {
      return new Promise((resolve, reject) => {
        this.chooseTypeFn = {
          resolve,
          reject
        };
      });
    },
    footerBtn() {
      if (this.dialogType === 'login') {
        this.$bury.registerClick(2);
        // 检测使用onehikid注册还是使用hpc注册
        const upgradeStrategy = isAccountNeedUpgrade(this.getCountryOrRegionIndex());
        if (upgradeStrategy > 0) {
          window.location.href = `${window.location.origin}/#/Register`;
        } else {
          this.dialogType = 'chooseId';
        }
      }
      if (this.dialogType === 'register') {
        this.$bury.loginDialog(1, 2);
        this.dialogType = 'login';
      }
      if (this.dialogType === 'reset') {
        this.dialogType = 'login';
      }
    },
    onCloseHPCLogin() {
      this.close();
      if (sessionStorage.getItem('updated_onehik')) {
        this.updatedOHIDialog = true;
      }
    },
    onCloseAzureLoginDialog() {
      const form = this.$refs.azureLoginForm;
      if (form) {
        form.resetValidates();
        form.resetFields();
      }
      this.azureLoginShow = false;
      this.googleLoginShow = false;
      this.needAzureVerifyCode = false;
    },
    // azureAD 的邮箱验证码
    changeAzureCode() {
      this.AzureVerifyImg = '';
      this.$nextTick(() => {
        // 增加随机数，火狐浏览器验证码切换问题
        const random = Math.random().toString(36).substring(2, 9);
        this.AzureVerifyImg = `/hpp/ccfauth/public/security/saml/captcha?lastSessionId=${this.azureSessionId}&r=${random}`;
      });
    },
    // 点击azureAD next step
    async confirmAzureEmail(event) {
      if (event) {
        event.preventDefault();
      }
      if (!this.validate()) {
        return;
      }
      let params = {
        ...(!this.googleLoginShow ? { account: this.azureLoginForm.email } : {}),
        accountType: 0,
        loginClient: 2,
        mode: this.googleLoginShow ? 1 : 0,
        ...(this.googleLoginShow ? { idpId: this.azureLoginForm.idpId } : {}) //Google Workspace登录需要传公司识别码idpId
      };
      if (!this.needAzureVerifyCode) {
        // 邮箱验证接口
        this.confirmLoading = true;
        const [data, err] = await this.$api.azureADCheckEmail(params).catch((error) => {
          console.log('error', error);
        }).finally(() => {
          this.confirmLoading = false;
        });
        if (data) {
          this.setGoogleStorage(params);
          // 成功直接跳转
          window.location.href = data.redirectUrl;
        }
        if (err) {
          console.log(err);
          // 失败打开验证码
          // 未找到邮箱打开报错提示
          if (err.errorCode) {
            if (['LAP001006', 'LAP001007', 'LAP001008', 'LAP001009'].includes(err.errorCode)) {
              this.verifyErrorTxt = err.errorCode;
            } else {
              this.setErrorMessage(err.errorCode);
            }
          } else {
            this.setErrorMessage('HPP-web_azure_login_no_exist_msg');
          }

          this.azureSessionId = err?.data?.sessionId;
          await this.changeAzureCode();
          this.needAzureVerifyCode = true;
        }
      } else {
        params.verifyCode = this.azureLoginForm.verifyCode;
        // params.lastSessionId = this.azureSessionId;
        // 邮箱加验证码验证接口
        this.confirmLoading = true;
        const [data, err] = await this.$api.azureADCheckEmail(params).catch((error) => {
          console.log('error', error);
        }).finally(() => {
          this.confirmLoading = false;
        });
        if (data) {
          this.setGoogleStorage(params);
          // 成功直接跳转
          window.location.href = data.redirectUrl;
        }
        if (err) {
          this.azureSessionId = err?.data?.sessionId;
          // 失败提示相关错误，继续验证码
          await this.changeAzureCode();

          if (err.errorCode === 'LAP001006'
              || err.errorCode === 'LAP001007'
              || err.errorCode === 'LAP001008'
              || err.errorCode === 'LAP001009') {
            this.verifyErrorTxt = err.errorCode || 'verify_code_error';
          } else {
            // 账号相关的错误码不显示在验证码的错误里
            this.setErrorMessage(err.errorCode);
          }
        }
      }
    },
    // azureLoginForm校验
    validate() {
      let result = false;
      this.$refs.azureLoginForm.validate((valid) => {
        result = valid;
      });
      return result;
    },
    //设置错误消息文本
    setErrorMessage(errorCode) {
      if (this.googleLoginShow) {
        this.idpIdErrorTxt = this.$t(errorCode);
      } else {
        this.noEmailErrorTxt = this.$t(errorCode);
      }
    },
    // 缓存google登录的公司识别码
    setGoogleStorage(params) {
      try {
        if (params.idpId) {
          sessionStorage.setItem('googleIpdId', params.idpId);
          storage.clear(); //落地页登录使用旧session问题
        }
      } catch {
        //设置缓存出错
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.icon-img_card_entry_bg {
  background-image: url('../../img/image_login_entry_bg.svg');
  background-repeat: no-repeat;
}
.entry-dialog {
  .bg-gray {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.55);
    z-index: 1998;
  }
  ::v-deep .el-form-item {
    &::after{
      position: absolute;
      content: '';
      display: block;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1px;
      border-bottom: rgba(0, 0, 0, 0.3) 1px solid;
    }
    .el-form-item__required-right {
      display: none;
    }
    .el-form-item__label {
      padding-right: 0;
      .el-form-item__label-text {
        max-width: 100% !important;
      }
    }
  }
  .foot-text {
    font-size: 14px;
  }
  .foot-button {
    font-weight: 500;
    font-size: 16px;
  }
  ::v-deep .el-input {
    .el-input__inner {
      padding: 16px 8px;
      border: none;
      height: 0;
      background-clip: content-box;
      @media screen and (min-width: 0\0) {
        height: 30px;
        padding: 0;
        background-color: transparent !important;
        transition: background-color 0s linear 3600s;
      }
    }
  }
  ::v-deep .entry-button {
    min-width: 100%;
    min-height: 40px;
  }
  .choose-country-style {
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0px;
    text-align: left;
  }
}
.updated_OHI_dialog_content {
  margin: 12px 14px;
  .updated_OHI_dialog_fail {
    font-size: 18px;
    color: #434343;
    font-weight: 500;
  }
  .updated_OHI_dialog_expain {
    padding: 17px 0 40px 0;
    font-size: 14px;
    color: #000000;
  }
  .updated_OHI_dialog_img {
    width: 432px;
    height: 172px;
    background: rgba(0, 0, 0, 0.02);
    border-radius: 4px;
    img {
      width: 398px;
      margin: 24px 17px;
    }
  }
}
.third-login-dialog {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>

<style lang="scss">
.icomoon-common_clos {
  cursor: pointer;
}

.icomoon-common_clos:hover {
  color: $theme-color;
}

.app-mode .entry-dialog {
  .bg-gray {
    height: calc(var(--app-visible-height) - 40px);
    top: 40px;
  }
  .dialog-card {
    width: 100vw;
    max-width: 100vw;
    height: calc(var(--app-visible-height) - 40px);
    min-height: calc(var(--app-visible-height) - 40px);
    top: 40px;
    left: 0;
    transform: none;
    border-radius: 0;
    animation: none;
    background-image: none;
    overflow: auto;

    > .header {
      padding: 25px 24px 0;
      height: auto;
      > span {
        font-size: 22px;
        color: rgba(0, 0, 0, 0.9);
        letter-spacing: 0;
        line-height: 30px;
        font-weight: 600;
      }

      .icomoon-common_clos {
        display: none;
      }
    }

    > .context {
      padding: 0;
      .choose-id {
        .content {
          width: 100%;
          .text {
            width: 100%;
            padding: 0 24px;
            margin-bottom: 0;
          }
          .service-card {
            width: 100%;
            max-width: 351px;
            min-width: 320px;
            height: auto;
            margin: 24px auto;
            box-shadow: 0 4px 8px 0 rgba(0, 43, 122, 0.06);
            border-radius: 8px;
            padding: 0 16px 16px;

            .text1 {
              margin-top: 4px;
            }

            .text2 {
              margin: 6px;
              width: 100%;
              max-height: none;
              -webkit-line-clamp: unset;
            }

            .button-style {
              margin-top: 0;
              border-radius: 20px;
              max-width: 231px !important;
              height: 40px;
            }
          }
        }
      }
    }

    > .footer {
      display: none;
    }
  }
}
.azure-login-form {
    margin-left: 12px;
    margin-right: 12px;
    .azure-login-code-pic {
        height: 40px;
        width: 124px;
        position: absolute;
        top: 24px;
        right: 0;
        cursor: pointer;
    }
    .azure-login-code-input{
        width: 348px
    }
}
</style>
